module.exports = __webpack_public_path__ + "img/mkdocs.7f1d93b7.svg";